import { ActivatedRoute } from '@angular/router';
import { DashboardHelper } from '../../../../../services/dashboard.service';
import { NgForm } from '@angular/forms';
import { IWorkspaceInstanceModel } from '../../../../../models/workspace/workspace-instance.model';
import { IEdgeInstanceModel } from '../../../../../models/edge-instance.model';
import { Component, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { WorkspaceStore } from '../../../../../services/stores/workspace.store';
import { LoggerService } from '../../../../../services/logger.service';
import { BaseComponent } from '../../../../../components/base/base.component';

@Component({
  selector: 'app-workspace-edge-property',
  templateUrl: './workspace-edge-property.component.html',
  styleUrls: ['./workspace-edge-property.component.css'],
  standalone: false,
})
export class WorkspaceEdgePropertyComponent extends BaseComponent implements AfterViewInit {
  className = 'WorkspaceEdgePropertyComponent';
  index: any;
  selectedWorkspaceInstanceEdge: IEdgeInstanceModel = {} as IEdgeInstanceModel;
  selectedWorkspace: IWorkspaceInstanceModel = {} as IWorkspaceInstanceModel;
  oldName: string = '';
  subscribers: any = {};
  locked = false;
  @ViewChild('myForm') myForm!: NgForm;

  constructor(
    private dashboardHelper: DashboardHelper,
    private workspaceStore: WorkspaceStore,
    private loggerService: LoggerService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subscribers.wsi = this.workspaceStore.$selectedWorkspaceInstance.subscribe((result) => {
        if (result) {
          this.selectedWorkspace = result;
          //this.loggerService.traceEnter(this.className, this.ngAfterViewInit.name, 'selectedWorkspaceInstance.subscribe', '', result);
          // console.log(this.workspaceStore.selectedWSIEdge);
          if (!this.workspaceStore.selectedWSIEdge) {
            this.subscribers.params = this.route.params.subscribe((params) => {
              if (params['id']) {
                if (this.selectedWorkspace) {
                  const edgeIns = this.selectedWorkspace.edgeInstances.find((ei) => ei?.id === params['id']);
                  if (edgeIns) {
                    // console.log('setting');
                    this.workspaceStore.selectedWSIEdge = edgeIns;
                  }
                  // this.dashboardHelper.showRightPanel();
                }
              }
            });
          }
        }
      });

      this.subscribers.edge = this.workspaceStore.$patchedEdgeInstance.subscribe((result) => {
        if (result) {
          //this.loggerService.traceEnter(this.className, this.ngAfterViewInit.name, 'patchedEdge.subscribe', '', result);
          this.locked = result ? result.locked : false;
          this.selectedWorkspaceInstanceEdge = result;
          this.oldName = this.selectedWorkspaceInstanceEdge.name;
          this.cdr.detectChanges();
        }
      });

      this.subscribers.edge = this.workspaceStore.$selectedWSIEdge.subscribe((result) => {
        if (result) {
          //this.loggerService.traceEnter(this.className, this.ngAfterViewInit.name, 'selectedWSIEdgeType.subscribe', '', result);
          this.locked = result ? result.locked : false;
          this.selectedWorkspaceInstanceEdge = result;
          this.oldName = this.selectedWorkspaceInstanceEdge.name;
          this.cdr.detectChanges();
        }
      });
    });
  }

  onNameBlur() {
    if (this.selectedWorkspaceInstanceEdge.name === '') {
      this.selectedWorkspaceInstanceEdge.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedWorkspaceInstanceEdge.id,
        name: this.selectedWorkspaceInstanceEdge.name,
      });
    } else {
      this.oldName = this.selectedWorkspaceInstanceEdge.name;
    }
  }

  saveWork() {
    // console.log('saving workspaceinstance...' + this.selectedWorkspace.id);
    // const patchPayload: PatchEdgeInstancePayload = new PatchEdgeInstancePayload();
    // patchPayload.id = this.selectedWorkspace.id;
    // patchPayload.edgeInstanceItem = this.selectedWorkspaceInstanceEdge;
    this.selectedWorkspaceInstanceEdge.workspaceId = this.selectedWorkspace.id;
    this.oldName = this.selectedWorkspaceInstanceEdge.name; // the latest name is saved as old name now
    // this.uiStateStore.startBackendAction('Saving Edge...');
    this.workspaceStore.$patchWSIEdge(this.selectedWorkspaceInstanceEdge).subscribe((result) => {
      // this.uiStateStore.endBackendAction('Edge Saved!');
      this.cdr.detectChanges();
      this.myForm.form.markAsPristine();
    });
    // this.uiHelper.closeRightPanel(this.router);
  }

  // onChange(val: string) {
  //   if (val === '') {
  //     return;
  //   }
  //   // console.log('selectedWorkspaceInstanceEdge:onChange:' + this.oldName);
  //   this.selectedWorkspace.edgeInstances[this.selectedWorkspace.edgeInstances.indexOf(this.selectedWorkspaceInstanceEdge)]
  //     = this.selectedWorkspaceInstanceEdge;

  //   this.workspaceService.setSelectedWSIEdgeType(this.selectedWorkspaceInstanceEdge);
  //   this.workspaceService.setSelectedWorkspace(this.selectedWorkspace);
  //   this.dashboardHelper.setModifiedPropertyItem({
  //     id: this.selectedWorkspaceInstanceEdge.id,
  //     name: this.selectedWorkspaceInstanceEdge.name
  //   });
  // }
}
